import React,{useEffect,useState} from "react";
import { useParams } from "react-router-dom";
import NotFound from "./NotFoundPage";
import images from "../../../images";
import loadingImg from "../../../images/igs_logo.png";
import styles from "../../../styles/news.module.css";
import { requesturl } from '../../../shared/utils/requesturl';

const BLOGS_API = `${requesturl}blogs.php`;
function Blogdetail(){
    const { title } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(BLOGS_API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => res.json())
        .then((data) => {
            const foundBlog = data.find((b) => b.title === title);
            setBlog(foundBlog);
            setLoading(false);
        })
        .catch((err) => {
            console.error(err);
            setLoading(false);
        });
    }, [title]);

    if (loading) {
        return <div className={styles.loadingContainer}>
            <img className={styles.loading} src={loadingImg} alt="Loading..." />
        </div>;
    }

    if (!blog) {
        return <div>
            <NotFound />
        </div>;
    }

    return (
        <div className={styles.newsWrapper}>
          <div className={styles.newsItem}>
            <img
              src={images["igs_logo"]}
              alt={blog.title}
              className={styles.newsImage}
            />
            <p className={styles.newsdate}>{blog.date}</p>
            <p className={blog.author}>Admin</p>
            <img
              src={images["library"]}
              alt={blog.title}
              className={styles.newsCoverImage}
            />

            <h2>
              {blog.title}
            </h2>
            <p>{blog.details}</p>

 
          </div>
          </div>
    );
}
export default Blogdetail;
